import { OriMuiThemeProvider } from '@ori-ui/material-ui';
import { TestIdProvider } from '@ori/testid-generator';
import bemCssModules from 'bem-css-modules';
import { configure } from 'mobx';
import type { VFC } from 'react';
import { HashRouter as Router } from 'react-router-dom';

import SupportCenterAppStyles from './SupportCenterApp.module.css';
import { IntlWrapper } from '~/components/IntlWrapper/IntlWrapper';
import { ErrorBoundary } from '~/containers/ErrorBoundary';
import { Routes } from '~/containers/Routes';
import type { Configuration } from '~/models/configuration';
import { StoreProvider } from '~/stores';

bemCssModules.setSettings({
  modifierDelimiter: '--',
  throwOnError: true,
});

configure({ enforceActions: 'observed' });

if (process.env.NODE_ENV !== 'production') {
  import('mobx-logger')
    .then((mobxLogger) => mobxLogger.enableLogging())
    .catch((error) => {
      throw error;
    });
}

const block = bemCssModules(SupportCenterAppStyles);

export const SupportCenterApp: VFC<Configuration> = (props) => (
  <ErrorBoundary>
    <OriMuiThemeProvider
      enableStylesProvider
      seed="support-center"
    >
      <TestIdProvider
        team="Presentation"
        project="support-center"
      >
        <div className={block()}>
          <StoreProvider configuration={props}>
            <IntlWrapper>
              <Router>
                <Routes />
              </Router>
            </IntlWrapper>
          </StoreProvider>
        </div>
      </TestIdProvider>
    </OriMuiThemeProvider>
  </ErrorBoundary>
);
